import { Backend, OrderByDirection } from '@freelancer/datastore/core';
import { ManageViewOngoingBidsCollection } from './manage-view-ongoing-bids.types';

export function manageViewOngoingBidsBackend(): Backend<ManageViewOngoingBidsCollection> {
  return {
    defaultOrder: {
      field: 'deadline',
      direction: OrderByDirection.DESC,
    },
    fetch: (authUid, ids, query, order) => ({
      endpoint: 'manage/bids.php',
      isGaf: true,
      params: {
        type: 'ongoing',
        filter:
          query && query.searchQueryParams && query.searchQueryParams.filter,
        query:
          query && query.searchQueryParams && query.searchQueryParams.query,
        offset:
          query && query.searchQueryParams && query.searchQueryParams.offset,
      },
    }),
    push: undefined,
    set: undefined,
    update: undefined,
    remove: undefined,
  };
}
